import React, { useState } from 'react';
import { newsletterData } from '../data';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const EMPTY_FORM = {
  firstName: '',
  lastName: '',
  email: '',
  message: '',
  consultation: false,
};

const Newsletter = () => {
  const { title, subtitle } = newsletterData;

  const [formData, setFormData] = useState(EMPTY_FORM);
  const [status, setStatus] = useState('idle'); // 'idle' | 'loading' | 'success' | 'error'
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const sendEmail = httpsCallable(functions, 'sendEmail');
      await sendEmail(formData);
      setStatus('success');
      setFormData(EMPTY_FORM);
      setShowModal(true);
    } catch (error) {
      console.error('Error sending email:', error);
      setStatus('error');
      setShowModal(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setStatus('idle');
  };

  return (
    <div className="bg-none lg:bg-newsletter lg:bg-cover lg:bg-center lg:px-24 xl:bg-auto">
      <div className="flex flex-col h-full justify-center items-center">
        {/* Title and Subtitle */}
        <div className="text-center lg:text-left mb-4">
          <h3 className="text-[26px] font-primary italic text-white capitalize mb-2">
            {title}
          </h3>
          <p className="capitalize text-white">{subtitle}</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex flex-col gap-4 items-center">
          {/* Row 1: First Name, Last Name, Email */}
          <div className="flex flex-col gap-4 lg:flex-row">
            <input
              className="input bg-transparent placeholder:font-light placeholder:text-white/20 text-white focus:ring-1 focus:ring-accent border border-white/20"
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
            />
            <input
              className="input bg-transparent placeholder:font-light placeholder:text-white/20 text-white focus:ring-1 focus:ring-accent border border-white/20"
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
            />
            <input
              className="input bg-transparent placeholder:font-light placeholder:text-white/20 text-white focus:ring-1 focus:ring-accent border border-white/20"
              type="email"
              name="email"
              placeholder="Email Address"
              required
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          {/* Row 2: Message */}
          <div className="w-full lg:h-[90px] flex items-center mb-5">
            <textarea
              className="input bg-transparent placeholder:font-light placeholder:text-white/20 text-white focus:ring-1 focus:ring-accent border border-white/20 w-full h-full resize-none p-6"
              name="message"
              placeholder="Your question or interest"
              value={formData.message}
              onChange={handleChange}
            />
          </div>

          {/* Row 3: Checkbox and Submit */}
          <div className="flex flex-col gap-2 items-center lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-center">
              <input
                type="checkbox"
                name="consultation"
                checked={formData.consultation}
                onChange={handleChange}
                className="mr-2"
              />
              <label className="text-white">
                I am interested in a free consultation
              </label>
            </div>
            <button
              className="btn capitalize w-full max-w-[204px] disabled:opacity-50"
              type="submit"
              disabled={status === 'loading'}
            >
              {status === 'loading' ? 'Sending...' : 'Submit'}
            </button>
            <span className="text-white/60 text-sm">Expect a reply within 24 hours</span>
          </div>
        </form>
      </div>

      {/* Confirmation Modal */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-2xl p-8 max-w-sm w-full mx-4 text-center shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            {status === 'success' ? (
              <>
                <div className="text-4xl mb-4">✓</div>
                <h4 className="text-xl font-primary font-semibold mb-2 text-gray-900">
                  Message Sent!
                </h4>
                <p className="text-gray-500 mb-6">
                  Thanks for reaching out. We'll get back to you within 1-2 business days.
                </p>
              </>
            ) : (
              <>
                <div className="text-4xl mb-4">✕</div>
                <h4 className="text-xl font-primary font-semibold mb-2 text-gray-900">
                  Something went wrong
                </h4>
                <p className="text-gray-500 mb-6">
                  We couldn't send your message. Please try again or reach out directly.
                </p>
              </>
            )}
            <button
              className="btn capitalize mx-auto block w-full max-w-[160px]"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Newsletter;
